export default __webpack_public_path__ + "static/media/meBooks.1c06d548.png";